import { ElementRef, inject, Signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { TellentBrand } from '@tellent/types';

import { Ability } from '@recruitee/abilities-types';
import type { FeatureDiscoveryFeatures } from '@recruitee/feature-discovery-types';
import {
  ComponentPositionPair,
  ComponentTooltipPosition,
  ObserveOnElement,
  OverlayClipArea,
} from '@recruitee/user-interface';

export interface FeatureTooltipData {
  id: string;
  isNew: boolean;
  title: string;
  description: string;
  learnMore?: string;
  learnMoreCopy?: string;
  ctaText?: string;
  positions?: Partial<Record<ComponentTooltipPosition, ComponentPositionPair>>;
  offsetX?: number;
  offsetY?: number;
  flagName?: keyof FeatureDiscoveryFeatures;
  requiredAbilities?: Ability[];
  brand?: TellentBrand;
}

export interface FeatureTooltipDirectiveConfig extends FeatureTooltipData {
  context: any;
  positions?: Partial<Record<ComponentTooltipPosition, ComponentPositionPair>>;
  overlayClipArea?: OverlayClipArea;
  observeOnElement?: ObserveOnElement;
  observeOnCustomElement?: Node | Signal<ElementRef<Node>>;
  withPush?: boolean;
}
export const welcomeVideoYoutubeUrl = (): SafeResourceUrl => {
  const domSanitizer = inject(DomSanitizer);
  const url = `https://www.youtube.com/embed/GTjKXVyr4lY`;
  // eslint-disable-next-line ban/ban
  return domSanitizer.bypassSecurityTrustResourceUrl(url);
};
